<template>
  <div id="app" >
     <index-header />
    <keep-alive>  
    　　<router-view  v-if="$route.meta.keepAlive" v-wechat-title='$route.meta.title' ></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" v-wechat-title='$route.meta.title'></router-view>
    <index-footer v-if="$route.path !== '/appreciate/vtour'"/>
  </div>
   
 
</template>

<style >  

</style>
<script>
import indexHeader from './components/indexHeader.vue'
import indexFooter from './components/indexFooter.vue'
export  default({
  name: 'app',
  components: {
     'index-header':indexHeader,
     'index-footer':indexFooter
  },
  provide (){
     return {
       reload:this.reload
     }
  },
  data(){
    return {
       isRouterAlive:true
    }
  },
  methods:{
    reload (){
       this.isRouterAlive = false
       this.$nextTick(function(){
          this.isRouterAlive = true
       })
    }
  },
})
</script>

